<div class="login-form-wp">
    <form class="form-group"
          autocomplete="off"
          [formGroup]="loginForm"
          (ngSubmit)="onSubmit()"
    >

        <div class="login-header">
            <h4>Log In</h4>
        </div>

        <div class="form-body">
            <div class="login-body">

                <div class="form-control-group">
                    <div class="title-and-error-row">
                        <label class="primary-text practice" for="practice">
                            Practice ID
                        </label>
                        <span class="primary-text error">*</span>
                    </div>

                    <input type="text" tabindex="1" autofocus
                           #iPractice
                           class="input-control"
                           formControlName="practice"
                           autocomplete="off"
                           placeholder="Practice ID"
                           (keydown)="keydownPractice($event)"
                           [ngClass]="{
                             'input-touched': loginForm.controls['practice'].touched && !loginForm.controls['practice'].value
                             }">

                    <div class="content__error" *ngIf="isPracticeError">
                        Invalid Practice ID
                    </div>
                    <div class="content__error" 
                        *ngIf=" loginForm.controls['practice'].touched && 
                                loginForm.controls['practice'].errors?.['required'] 
                                && !isPracticeError">
                        Practice ID required
                    </div>                            
                </div>

                <div class="form-control-group">
                    <div class="title-and-error-row">
                        <label class="primary-text username" for="user">
                            Username
                        </label>
                        <span class="primary-text error">*</span>
                    </div>

                    <input type="text" tabindex="2"
                           class="input-control"
                           formControlName="user"
                           autocomplete="off"
                           placeholder="Username"
                           [ngClass]="{
                            'input-touched': loginForm.controls['user'].touched && !loginForm.controls['user'].value
                            }">

                        <div class="content__error" *ngIf="isUserNamePasswordError">
                            Invalid username or password
                        </div>
                        <div class="content__error" 
                            *ngIf=" loginForm.controls['user'].touched && 
                                    loginForm.controls['user'].errors?.['required'] 
                                    && !isUserNamePasswordError">
                            Username required
                        </div>                            
                </div>

                <div class="form-control-group">
                    <div class="title-and-error-row">
                        <label class="primary-text password" for="password">
                            Password
                        </label>
                        <span class="primary-text error">*</span>

                        <div class="forgot-password" tabindex="6">
                            <a #aForgotPassword
                                href="" 
                                class="forgot-password-text" 
                                (click)="onForgotPasswordClicked($event)"
                            >
                                Forgot password?
                            </a>
                        </div>        
                    </div>

                    <input tabindex="3"
                        type="{{ showPassword ? 'text' : 'password' }}"
                        class="input-control"
                        placeholder="Password"
                        formControlName="password"
                        autocomplete="new-password"
                        (keydown)="keydownPasswordEvent($event)"
                        [ngClass]="{
                          'input-touched': loginForm.controls['password'].touched && !loginForm.controls['password'].value
                           }">

                    <ds-icon 
                        name="eye" 
                        *ngIf="loginForm.controls['password'].value"
                        [size]="20" 
                        class="svg-eye" 
                        (click)="toggleShowPassword()" 
                        [ngClass]="{ 'active': showPassword }">
                    </ds-icon>

                    <div class="content__error" *ngIf="isUserNamePasswordError">
                        Invalid username or password
                    </div>
                    <div class="content__error" 
                        *ngIf=" loginForm.controls['password'].touched && 
                                loginForm.controls['password'].errors?.['required'] 
                                && !isUserNamePasswordError">
                        Password required
                    </div>                
                </div>

            </div>

            <div class="after-body-content" tabindex="4">
                <div class="remember">
                    <mat-slide-toggle #cbRememberMe
                        id="remember-me" 
                        formControlName="remember_me">
                    </mat-slide-toggle>
                    <label for="remember-me" class="remember-text">
                        Remember me
                    </label>
                </div>
            </div>

            <ds-button #btSubmit tabindex="5"
                type="submit" 
                [isDisabled]="!loginForm.valid" 
                [ngClass]="{ 'disabled-button': !loginForm.valid}" 
                [isLoading]="isLoading" 
                class="button-submit" 
                [processingText]="'Logging in...'" >
                Log In
            </ds-button>

        </div>

    </form>
</div>

<pnl-recent-login-manager *ngIf="(loginService.recentLogins$ | async)?.length">
</pnl-recent-login-manager>